import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import FinancialBankSlipForm from '@/components/Reports/FinancialReports/FinancialBankSlipForm';
import { useBankSlipReport } from '@/core/domain/reports/financial/BankSlip/BankSlip.hooks';
import {
  BankSlipReportFormValues,
  BankSlipReportRequest,
} from '@/core/domain/reports/financial/BankSlip/BankSlip.types';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { useReportHandlers } from '@/hooks/useReportHandler';
import { PageProps } from '@/types/PageProps';
import { Divider, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function FinancialBankSlip({ route }: PageProps) {
  const intl = useIntl();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const [form] = Form.useForm<BankSlipReportFormValues>();
  const generateReport = useBankSlipReport();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const values = await form.validateFields();

      const obj: BankSlipReportRequest = {
        ...values,
        initialDate: values.initialDate.format('YYYY-MM-DD'),
        finalDate: values.finalDate.format('YYYY-MM-DD'),
      };

      const result = await generateReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf } = useReportHandlers(
    'relatorio_boleto_bancario',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <FinancialBankSlipForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
